import { KendoBaseComponent } from '@progress/kendo-base-components-vue-wrapper'
import NotificationProps from './NotificationProps'

import Position from './Position'
import Templates from './Templates'
import Animation from '../Common/Animation'

export default {
    props: NotificationProps,
    render (h) {
        return h('span')
    },
    mixins: [
        KendoBaseComponent,
        Position,
        Templates,
        Animation
    ],
    mounted() {
        kendo.jQuery(this.$el).kendoNotification(this.widgetOptions)

        this.$emit('kendowidgetready', this.kendoWidget())
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoNotification()
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-popups-vue-wrapper/src/KendoNotification/KendoNotificationMixin.js